export default __webpack_public_path__ + "static/media/checkmark-ellipse.bb0dbd26.svg";